import { mix } from "@chorda/core";
export const Delete = (props) => {
    return mix({
        css: 'delete'
    }, props && {
        css: props.css,
        events: {
            $dom: {
                click: props.onClick
            }
        }
    });
};
